// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CustomErrorClass, ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { Resources } from '@shared/localizations/Resources';
import { OrderTypeBase } from '@shared/commons/cache/OrderParams/order-type/OrderTypeBase';
import AdvancedChartOrderEntryTemplate from '@front/templates/AdvancedChartOrderEntryTemplate.html';
import OrderEntryChartSellButtonsTemplate from '@front/templates/OrderEntryChartSellButtonsTemplate.html';
import OrderEntryChartBuyButtonsTemplate from '@front/templates/OrderEntryChartBuyButtonsTemplate.html';
import { ContainerControl } from '../elements/ContainerControl';
import { OrderEntryBase } from '../OrderEntryBase';
import { OETIFSelector } from '../trading/OE/OETIFSelector';
import { SlTpPriceType } from '@shared/utils/Enums/Constants';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { PlacedFrom } from '@shared/utils/Trading/PlacedFrom';
import { Account } from '@shared/commons/cache/Account';
import { TIF } from '@shared/utils/Trading/OrderTif';
import { SlTpNumericInputParameters, SlTpUtils } from '@shared/utils/Trading/SlTpUtils';
import { TradingLockUtils } from '@shared/utils/TradingLockUtils';
import { IsAllowed } from '@shared/commons/IsAllowed';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { SlTpHolder } from '@shared/utils/Trading/SlTpHolder';
import { OrderEditUpdateData } from '@shared/utils/Trading/OrderEditUpdateData';
import { SLTPTriggerUtils } from '@shared/commons/cache/OrderParams/SLTPTriggerUtils';
import { OCOCustomOrdersEdit } from '@shared/commons/cache/OrderParams/order-edit/OCOCustomOrdersEdit';
import { DataCache } from '@shared/commons/DataCache';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { TradingNumericErrorChecker } from '@shared/commons/Trading/TradingNumericErrorChecker';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { WDSettings } from '../settings/WDGeneralSettings';
import { WDSettingsUtils } from '../UtilsClasses/WDGeneralSettingsUtils';
import { OffsetModeViewEnum } from '@shared/utils/Trading/OffsetModeViewEnum';
import { SLTPMode } from '@shared/commons/cache/OrderParams/SLTPEdit';
import { BaseSettings } from '@shared/commons/Settings/BaseGeneralSettingsWrapper';
export class AdvancedChartOrderEntry extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.AdvancedChartOrderEntry;
    }
    // http://tp.pfsoft.net/entity/57421
    // TODO.
    oncomplete() {
        super.oncomplete();
        TradingLockUtils.TradingLock.TradingLockChanged.Subscribe(this.updateTradingAllowedStuff, this);
        Account.TradeStatusChanged.Subscribe(this.updateTradingAllowedStuff, this);
        WDSettings.settingsChanged.Subscribe(this.onSettingsChanged, this);
        DataCache.OnUpdateInstrument.Subscribe(this.onUpdateInstrument, this);
        void this.set({
            accountItem: this.get('accountItem'),
            instrumentItem: this.get('instrumentItem')
        });
        this.observe('instrumentItem', this.onInstrumentItemChanged);
        this.observe('accountItem', this.onAccountItemChanged);
        this.observe('showSLTP', (newValue, oldVal) => {
            this.showHideSLTP(newValue);
            // this.onrender();
        });
        this.observe('enabledSL', this.onSlChecked);
        this.observe('trStopChecked', this.onTrStopChecked);
        this.observe('selectedItem', this.selectedItemChanged);
        this.observe('isVisibleOTHTrading', this.updateIsAllowOTHTrading);
        this.localize();
    }
    selectedItemChanged() { }
    showHideSLTP(isShow) {
        const myHeigth = 500;
        if (isShow) {
            void this.set({ height: myHeigth });
            // разместить размер с вдимыми слтп
        }
        else {
            void this.set({ height: myHeigth - 85 });
            // разместить размер с не вдимыми слтп
        }
    }
    oninit() {
        super.oninit();
        void this.set('numericsErrors', {});
        void this.set('reverseButtons', WDSettings.reverseButtonsOrder);
        this.observe('accountItem instrumentItem', this.updateTradingAllowedStuff);
        this.observe('instrumentItem defaultTif', this.repopulateTIFComboBox);
        this.observe('selectedItem gtdDate', this.updateTIF);
        this.observe('productType', this.onProductTypeChanged);
        this.on('add_Ask', this.addAskButton_Click);
        this.on('sell_Bid', this.sellBidButton_Click);
        this.on('sell_market', this.sellMarketButton_Click);
        this.on('buy_market', this.buyMarketButton_Click);
        this.on('buy_Ask', this.buyAskButton_Click);
        this.on('add_Bid', this.addBidButton_Click);
    }
    dispose() {
        TradingLockUtils.TradingLock.TradingLockChanged.UnSubscribe(this.updateTradingAllowedStuff, this);
        Account.TradeStatusChanged.UnSubscribe(this.updateTradingAllowedStuff, this);
        WDSettings.settingsChanged.UnSubscribe(this.onSettingsChanged, this);
        DataCache.OnUpdateInstrument.UnSubscribe(this.onUpdateInstrument, this);
        const instrument = this.get('instrumentItem');
        if (!isNullOrUndefined(instrument)) {
            instrument.RiskSettingsUpdated.UnSubscribe(this.updateTradingAllowedStuff, this);
        }
        super.dispose();
    }
    onAccountItemChanged(newItem, prewItem) {
        if (isNullOrUndefined(newItem)) {
            return;
        }
        this.updateIsVisibleOTHTrading();
    }
    onInstrumentItemChanged(newItem, prewItem) {
        if (isNullOrUndefined(newItem)) {
            return;
        }
        this.subscribeRiskSettingsUpdate(newItem, prewItem);
        this.clearNumerics();
        this.setDeafultSL(newItem);
        this.setDeafultTP(newItem);
        this.updateSlTpNumericRightAlignedText(newItem);
        this.updateIsVisibleOTHTrading();
        // this.set('productTypeShow', newItem.isProductTypeVisible(this.get('accountItem')))
    }
    subscribeRiskSettingsUpdate(instrument, lastInstrument) {
        if (!isNullOrUndefined(lastInstrument)) {
            lastInstrument.RiskSettingsUpdated.UnSubscribe(this.updateTradingAllowedStuff, this);
        }
        if (!isNullOrUndefined(instrument)) {
            instrument.RiskSettingsUpdated.Subscribe(this.updateTradingAllowedStuff, this);
        }
    }
    onUpdateInstrument(instrument) {
        const myInstrument = this.get('instrumentItem');
        if (!isNullOrUndefined(myInstrument) && myInstrument === instrument) {
            this.updateTradingAllowedStuff();
        }
    }
    updateTradingAllowedStuff() {
        const acc = this.get('accountItem');
        const ins = this.get('instrumentItem');
        if (isNullOrUndefined(acc) || isNullOrUndefined(ins)) {
            return;
        }
        this.PopulateOrderTypes();
        const tradingMarketAllowed = IsAllowed.IsTradingAllowed(acc, ins, OrderType.Market);
        const tradingLimitAllowed = OrderTypeBase.IsSupported(OrderType.Limit, ins);
        const tradingLimitAllowedS = IsAllowed.IsTradingAllowed(acc, ins, OrderType.Limit);
        const slVisible = IsAllowed.IsSLTPAllowed(ins, acc, true).Allowed;
        const tpVisible = IsAllowed.IsSLTPAllowed(ins, acc, false).Allowed;
        const sltpVisible = slVisible || tpVisible;
        const sltpHeight = slVisible && tpVisible;
        const newProductTypeShow = ins.isProductTypeVisible(acc);
        if (this.get('productTypeShow') !== newProductTypeShow) {
            void this.set('productTypeShow', newProductTypeShow);
        }
        void this.set({
            reverseButtons: WDSettings.reverseButtonsOrder,
            isSlVisible: slVisible,
            isTPVisible: tpVisible,
            isSlTPVisible: sltpVisible,
            isSLTPheight: sltpHeight,
            tradingMarketAllowed: tradingMarketAllowed.Allowed,
            tradingMarketAllowedReason: tradingMarketAllowed.ReasonText,
            tradingLimitAllowed: tradingLimitAllowedS.Allowed && tradingLimitAllowed,
            tradingLimitAllowedReason: tradingLimitAllowedS.ReasonText,
            trStopAllowed: IsAllowed.IsTrailingStopForSLAllowed(ins, acc).Allowed
        });
    }
    PopulateOrderTypes() {
        const ins = this.get('instrumentItem');
        if (isNullOrUndefined(ins))
            return;
        if (DataCache.OrderParameterContainer === null) {
            return;
        }
        const orderTypes = OrderEntryBase.PopulateOrderTypes(this.get('accountItem'), ins, null, WDSettings.orderType, false);
        const marketAllow = orderTypes.includes(OrderType.Market);
        const limitAllow = orderTypes.includes(OrderType.Limit);
        const showSellBidBuyAsk = !Resources.isHidden('property.OE_ShowSellBidBuyASk');
        const addBidAddAsk = !Resources.isHidden('property.OE_AddBidAddAsk');
        void this.set({
            buyMarketButtonOnSmallOE: marketAllow,
            buyAskButtonOnSmallOE: limitAllow && showSellBidBuyAsk,
            addBidButtonOnSmallOE: limitAllow && addBidAddAsk,
            sellMarketButtonOnSmallOE: marketAllow,
            sellBidButtonOnSmallOE: limitAllow && showSellBidBuyAsk,
            addAskButtonOnSmallOE: limitAllow && addBidAddAsk
        });
    }
    clearNumerics() {
        void this.set({
            tpNumericStep: 0,
            slNumericStep: 0,
            tpNumericPrecision: 0,
            slNumericPrecision: 0,
            minSLPrice: 0,
            minTPPrice: 0,
            priceSL: 0,
            priceTP: 0
        });
    }
    localize() {
        void this.set({
            addAskText: Resources.getResource('panel.newOrderEntry.AddAskButton'),
            sellBidText: Resources.getResource('panel.newOrderEntry.SellBidButton'),
            sellMarketText: Resources.getResource('panel.newOrderEntry.SellMarketButton'),
            buyMarketText: Resources.getResource('panel.newOrderEntry.BuyMarketButton'),
            buyAskText: Resources.getResource('panel.newOrderEntry.BuyAskButton'),
            addBidText: Resources.getResource('panel.newOrderEntry.AddBitButton'),
            sllLabelTooltip: 'panel.newOrderEntry.stopLimitLimitOffset.tt'
        });
    }
    onProductTypeChanged(productType) {
        const ins = this.get('instrumentItem');
        const acc = this.get('accountItem');
        void this.set('isLeverageVisible', !isNullOrUndefined(ins) ? ins.isLeverageVisible(acc, productType) : false);
    }
    onSettingsChanged() {
        void this.update('instrumentItem');
    }
    addBidButton_Click() {
        const ins = this.get('instrumentItem');
        this.placeFromSmallBtn(OrderType.Limit, OperationType.Buy, ins.Level1.GetBid());
    }
    addAskButton_Click() {
        const ins = this.get('instrumentItem');
        this.placeFromSmallBtn(OrderType.Limit, OperationType.Sell, ins.Level1.GetAsk());
    }
    buyAskButton_Click() {
        const ins = this.get('instrumentItem');
        this.placeFromSmallBtn(OrderType.Limit, OperationType.Buy, ins.Level1.GetAsk());
    }
    sellBidButton_Click() {
        const ins = this.get('instrumentItem');
        this.placeFromSmallBtn(OrderType.Limit, OperationType.Sell, ins.Level1.GetBid());
    }
    buyMarketButton_Click() {
        this.placeFromSmallBtn(OrderType.Market, OperationType.Buy);
    }
    sellMarketButton_Click() {
        this.placeFromSmallBtn(OrderType.Market, OperationType.Sell);
    }
    // TODO. UGLY.
    placeFromSmallBtn(type, side, price) {
        const params = {
            dPrice: price,
            dStopPrice: price,
            lOrdType: type,
            lBuySell: side,
            lTif: this.get('selectedItem').value,
            expireTime: this.get('gtdDate'),
            productType: this.get('productType'),
            leverageValue: this.get('leverageValue'),
            isAllowOTHTrading: this.get('isAllowOTHTrading'),
            placedFrom: PlacedFrom.WEB_CHART_OE
        };
        void this.OrderParamsSet(params);
    }
    repopulateTIFComboBox() {
        OETIFSelector.PopuplateTifComboboxAsync([OrderType.Limit, OrderType.Market], this);
    }
    updateTIF() {
        OETIFSelector.GetAdvancedUpdateTIF(this);
    }
    OrderParamsSet(orderParams_1) {
        return __awaiter(this, arguments, void 0, function* (orderParams, callComponent = this) {
            var _a;
            if (TradingNumericErrorChecker.HasErrors(callComponent)) {
                return;
            }
            if (isNullOrUndefined(orderParams)) {
                return;
            }
            const orderType = orderParams.lOrdType;
            const orderTypeObj = DataCache.OrderParameterContainer.OrderTypes[orderType];
            const orderEditCtorData = {
                dataCache: DataCache,
                // TODO. UGLY. Details are in OrderEditBase
                sltpMode: SLTPMode.Offset
            };
            // TODO. Ugly.
            const orderEdit = orderType === OrderType.OCO
                ? new OCOCustomOrdersEdit(orderEditCtorData)
                : orderTypeObj.createOrderEditObject(orderEditCtorData);
            orderEdit.updateParameters(new OrderEditUpdateData(null, {
                account: this.get('accountItem'),
                instrument: this.get('instrumentItem'),
                side: orderParams.lBuySell,
                quantity: new Quantity((_a = orderParams.quantity) !== null && _a !== void 0 ? _a : this.get('quantity').value, WDSettingsUtils.displayAmountInLots()),
                tif: new TIF(orderParams.lTif, orderParams.expireTime),
                productType: orderParams.productType,
                leverageValue: orderParams.leverageValue,
                isAllowOTHTrading: orderParams.isAllowOTHTrading,
                placedFrom: orderParams.placedFrom
            }));
            const chartSLTPHolder = this.getChartSLTPHolder();
            // TODO. Ugly.
            switch (orderType) {
                case OrderType.Limit:
                    orderEdit.setLimitPrice(orderParams.dPrice);
                    break;
                case OrderType.Stop:
                    orderEdit.setStopPrice(orderParams.dStopPrice);
                    break;
                case OrderType.StopLimit:
                    orderEdit.setBasePrice(orderParams.dStopPrice);
                    break;
                case OrderType.OCO:
                    this.setOCOOrderEdit(orderEdit, orderParams);
                    break;
            }
            // TODO. Ugly.
            orderEdit.setSLTP({ sltpHolder: chartSLTPHolder });
            return yield DataCache.FOrderExecutor.placeOrderPromise(orderEdit)
                .catch(function () {
                const ex = new CustomErrorClass('AdvancedChartOrderEntry error', 'AdvancedChartOrderEntry.OrderParamsSet', 'OrderParamsSet -> placeOrderPromise');
                ErrorInformationStorage.GetException(ex);
            })
                .finally(function () {
                // TODO. Refactor.
                orderEdit.dispose();
            });
        });
    }
    setOCOOrderEdit(orderEdit, orderParams) {
        orderEdit.setOrdersTypes(orderParams.OCO_firstOrder_OrderType, orderParams.OCO_secondOrder_OrderType);
        orderEdit.setOrdersSides(orderParams.lBuySell, orderParams.OCO_secondOrder_Operation);
        // TODO.
        orderEdit.setOrdersPrices(orderParams.dPrice, orderParams.dStopPrice);
        let firstTif, secondTif;
        if (!isNullOrUndefined(orderParams.lTif)) {
            firstTif = secondTif = new TIF(orderParams.lTif, orderParams.expireTime);
        }
        else {
            const ins = this.get('instrumentItem');
            firstTif = new TIF(SessionSettings.getDefaultTifForOrderType(orderParams.OCO_firstOrder_OrderType), TIF.getDefaultExpireTimeForOrderType(orderParams.OCO_firstOrder_OrderType, ins));
            secondTif = new TIF(SessionSettings.getDefaultTifForOrderType(orderParams.OCO_secondOrder_OrderType), TIF.getDefaultExpireTimeForOrderType(orderParams.OCO_secondOrder_OrderType, ins));
        }
        orderEdit.setOrdersTifs(firstTif, secondTif);
    }
    getChartSLTPHolder() {
        // Chart SL/TP are always offset.
        const instrument = this.get('instrumentItem');
        const sltpHolder = new SlTpHolder();
        const slEnabled = this.get('enabledSL') && !this.get('trStopChecked');
        const trStopEnabled = this.get('enabledSL') && this.get('trStopChecked');
        if (slEnabled || trStopEnabled) {
            const slVisualOffsetType = trStopEnabled
                ? SlTpUtils.getDefaultVisualOffsetTypeExcludePercent(instrument)
                : SlTpUtils.getDefaultVisualOffsetType(instrument);
            const slPriceType = trStopEnabled ? SlTpPriceType.TrOffset : SlTpUtils.getSLTPPriceType(slVisualOffsetType);
            sltpHolder.StopLossPriceType = slPriceType;
            sltpHolder.StopLossPriceValue = SlTpUtils.toRealValue(this.get('priceSL'), instrument, slVisualOffsetType);
            if (this.get('isSLLVisible')) {
                sltpHolder.StopLossLimitPriceValue = SlTpUtils.toRealValue(this.get('priceSLL'), instrument, slVisualOffsetType);
            }
        }
        const tpEnabled = this.get('enabledTP');
        if (tpEnabled) {
            const slDefaultVisualOffsetType = SlTpUtils.getDefaultVisualOffsetType(instrument);
            sltpHolder.TakeProfitPriceType = SlTpUtils.getSLTPPriceType(slDefaultVisualOffsetType);
            sltpHolder.TakeProfitPriceValue = SlTpUtils.toRealValue(this.get('priceTP'), instrument, slDefaultVisualOffsetType);
        }
        const anyEnabled = slEnabled || trStopEnabled || tpEnabled;
        if (anyEnabled) {
            /* #110841 */
            sltpHolder.SLTPTriggerShortValue = SLTPTriggerUtils.GetTriggersShortForInstrument(instrument);
        }
        return sltpHolder;
    }
    updateIsVisibleOTHTrading() {
        const account = this.get('accountItem');
        const instrument = this.get('instrumentItem');
        const isVisible = !isNullOrUndefined(account) && !isNullOrUndefined(instrument) && account.isAllowOTHTrading(instrument);
        this.set('isVisibleOTHTrading', isVisible);
    }
    updateIsAllowOTHTrading() {
        const isVisible = this.get('isVisibleOTHTrading');
        const isAllowOTHTrading = this.get('isAllowOTHTrading');
        if (isVisible) {
            if (isNullOrUndefined(isAllowOTHTrading)) {
                this.set('isAllowOTHTrading', BaseSettings.isAllowOTHTrading);
            }
        }
        else {
            this.set('isAllowOTHTrading', null);
        }
    }
    onSlChecked() {
        this.sLLVisibleCheck();
    }
    onTrStopChecked() {
        this.sLLVisibleCheck();
        const instrument = this.get('instrumentItem');
        const defaultOffset = SlTpUtils.getDefaultVisualOffsetType(instrument);
        if (defaultOffset === OffsetModeViewEnum.Percent) {
            this.setDeafultSL(instrument);
            this.updateSlTpNumericRightAlignedText(instrument);
        }
    }
    sLLVisibleCheck() {
        const slEnabled = this.get('enabledSL');
        const trStopChecked = this.get('trStopChecked');
        const useStopLimitInsteadStop = WDSettings.isUseStopLimitInsteadStop();
        const sllNewVisibility = slEnabled && !trStopChecked && useStopLimitInsteadStop;
        void this.set('isSLLVisible', sllNewVisibility);
    }
    updateSlTpNumericRightAlignedText(instrument) {
        const slOffsetType = this.get('trStopChecked')
            ? SlTpUtils.getDefaultVisualOffsetTypeExcludePercent(instrument)
            : SlTpUtils.getDefaultVisualOffsetType(instrument);
        const slNumericRightAlignedText = SlTpUtils.getSymbolForOffsetMode(slOffsetType);
        const tpNumericRightAlignedText = SlTpUtils.getSymbolForOffsetMode(slOffsetType);
        void this.set({ slNumericRightAlignedText, tpNumericRightAlignedText });
    }
    setDeafultSL(instrument) {
        if (isNullOrUndefined(instrument)) {
            return;
        }
        const offsetType = this.get('trStopChecked')
            ? SlTpUtils.getDefaultVisualOffsetTypeExcludePercent(instrument)
            : SlTpUtils.getDefaultVisualOffsetType(instrument);
        const sltpNumericInputParameters = new SlTpNumericInputParameters(instrument, offsetType);
        const settings = SlTpUtils.getSlTpNumericParameters(sltpNumericInputParameters);
        const insDefSettings = WDSettings.insDefSettingsStorage.GetInstrumentSettings(instrument);
        const slTickOffset = !isNullOrUndefined(insDefSettings)
            ? insDefSettings.getDefaultSLOffset(offsetType === OffsetModeViewEnum.Percent)
            : 1;
        const defaultSL = SlTpUtils.toVisualValue(slTickOffset, instrument, offsetType);
        void this.set({
            slNumericStep: settings.step,
            slNumericPrecision: settings.precision,
            minSLPrice: settings.step,
            priceSL: defaultSL,
            priceSLL: defaultSL
        });
    }
    setDeafultTP(instrument) {
        if (isNullOrUndefined(instrument)) {
            return;
        }
        const offsetType = SlTpUtils.getDefaultVisualOffsetType(instrument);
        const sltpNumericInputParameters = new SlTpNumericInputParameters(instrument, offsetType);
        const settings = SlTpUtils.getSlTpNumericParameters(sltpNumericInputParameters);
        const insDefSettings = WDSettings.insDefSettingsStorage.GetInstrumentSettings(instrument);
        const tpTickOffset = !isNullOrUndefined(insDefSettings)
            ? insDefSettings.getDefaultTPOffset(offsetType === OffsetModeViewEnum.Percent)
            : 1;
        const defaultTP = SlTpUtils.toVisualValue(tpTickOffset, instrument, offsetType);
        void this.set({
            tpNumericStep: settings.step,
            tpNumericPrecision: settings.precision,
            minTPPrice: settings.step,
            priceTP: defaultTP
        });
    }
}
ContainerControl.extendWith(AdvancedChartOrderEntry, {
    template: AdvancedChartOrderEntryTemplate,
    partials: {
        chartSellButtons: OrderEntryChartSellButtonsTemplate,
        chartBuyButtons: OrderEntryChartBuyButtonsTemplate
    },
    data: function () {
        return {
            accountItem: null,
            instrumentItem: null,
            oeSmall: true,
            reverseButtons: false,
            enabledSL: false,
            enabledTP: false,
            isSlTPVisible: true,
            isSlVisible: true,
            isTPVisible: true,
            isSLTPheight: true,
            isSLLVisible: false,
            priceSL: 0.1,
            priceSLL: 0.1, // #91413
            priceTP: 0.1,
            minSLPrice: 0.1,
            maxSLPrice: 99999999,
            minSLLPrice: -99999999,
            minTPPrice: 0.1,
            maxTPPrice: 99999999,
            slNumericStep: 0.00001,
            tpNumericStep: 0.00001,
            slNumericPrecision: 2,
            tpNumericPrecision: 2,
            slNumericRightAlignedText: '',
            tpNumericRightAlignedText: '',
            trStopChecked: false,
            trStopAllowed: true,
            numericsErrors: {},
            sellMarketButtonOnSmallOE: true,
            sellBidButtonOnSmallOE: true,
            addAskButtonOnSmallOE: true,
            _userPreferredShowBuySellMarket: true,
            _userPreferredShowSellBidBuyAsk: true,
            _userPreferredShowAddBidAsk: true,
            addAskText: 'Add Ask',
            sellBidText: 'Sell Bid',
            sellMarketText: 'Sell Market',
            buyMarketText: 'Buy Market',
            buyAskText: 'Buy Ask',
            addBidText: 'Add Bid',
            sllLabelTooltip: '',
            tif: null,
            items: null,
            gtdDate: null,
            orderTypeId: null,
            selectedItem: null,
            productType: null,
            productTypeShow: false,
            isLeverageVisible: false,
            overnightExecutionTextKey: 'panel.newOrderEntry.OvernightExecution.Short',
            overnightExecutionTooltipKeyActive: 'panel.newOrderEntry.OvernightExecution.Info.Active',
            overnightExecutionTooltipKeyInActive: 'panel.newOrderEntry.OvernightExecution.Info.InActive',
            isVisibleOTHTrading: false,
            isAllowOTHTrading: null,
            isAllowOTHTradingEvents: {
                onActiveChanged: (isActive) => {
                    this.set('isAllowOTHTrading', isActive);
                }
            },
            // TODO. Remove. Ugly.
            defaultTif: null
        };
    }
});
